import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=32a6a5a6"
import script from "./table-list.vue?vue&type=script&lang=js"
export * from "./table-list.vue?vue&type=script&lang=js"
import style0 from "./table-list.vue?vue&type=style&index=0&id=32a6a5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports